import React from 'react';
import { Button } from '@mantine/core';

interface BottomButtonProps {
  label: string;
  loading: boolean;
  icon: React.ReactNode;
  onClick?: () => void;
  className?: string;
  dataIntercomTarget?: string;
}

const BottomButton: React.FC<BottomButtonProps> = ({ loading, label, icon, onClick, className, dataIntercomTarget }) => {
  return (
    <Button
      data-intercom-target={dataIntercomTarget}
      loading={loading}
      onClick={onClick}
      leftIcon={icon}
      size={'xs'}
      className={className}
      styles={{
        root: {
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          // padding: '8px 8px',
          borderRadius: '4px',
          border: '1px solid rgba(79, 79, 79, 1)',
          background: 'rgba(52, 52, 52, 1)',
          color: 'rgba(224, 224, 224, 1)',
          fontSize: '12px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            background: 'rgba(79, 79, 79, 1)',
            borderColor: '0 0 0 1px #444',
          },
        },
        leftIcon: {
          marginRight: 8,
          display: 'flex',
          alignItems: 'center',
        },
      }}
      variant="default"
    >
      {label}
    </Button>
  );
};

export default BottomButton;
